import { InternalApiDispatcher } from '@tableau/api-internal-contract-js';

import { DataSourceServiceImpl } from './impl/DataSourceServiceImpl';
import { FilterServiceImpl } from './impl/FilterServiceImpl';
import { GetDataServiceImpl } from './impl/GetDataServiceImpl';
import { NotificationServiceImpl } from './impl/NotificationServiceImpl';
import { ParametersServiceImpl } from './impl/ParametersServiceImpl';
import { SelectionServiceImpl } from './impl/SelectionServiceImpl';
import { ApiServiceRegistry } from './ServiceRegistry';

export function registerAllSharedServices(dispatcher: InternalApiDispatcher): void {
  ApiServiceRegistry.instance.registerService(new DataSourceServiceImpl(dispatcher));
  ApiServiceRegistry.instance.registerService(new GetDataServiceImpl(dispatcher));
  ApiServiceRegistry.instance.registerService(new FilterServiceImpl(dispatcher));
  ApiServiceRegistry.instance.registerService(new NotificationServiceImpl(dispatcher));
  ApiServiceRegistry.instance.registerService(new ParametersServiceImpl(dispatcher));
  ApiServiceRegistry.instance.registerService(new SelectionServiceImpl(dispatcher));
}



// WEBPACK FOOTER //
// ../../../../src/ApiShared/Services/RegisterAllSharedServices.ts


// WEBPACK FOOTER //
// webpack:///src/ApiShared/Services/RegisterAllSharedServices.ts